import React, { useEffect, useRef } from "react";
import "../../style.css";
import { Container, Row, Col } from "react-bootstrap";
import Home2 from "./Home2";
import "@fontsource/space-grotesk";
import Type from "./Type";
import { useScrollAnimation } from "../../hooks/useScrollAnimation";

function Home() {
  useScrollAnimation();
  const parallaxRef = useRef(null);

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!parallaxRef.current) return;
      const x = (e.clientX / window.innerWidth - 0.5) * 18;
      const y = (e.clientY / window.innerHeight - 0.5) * 10;
      parallaxRef.current.style.transform = `translate(${x}px, ${y}px)`;
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Container>
          <Row className="justify-content-center">
            <Col
              md={12}
              className="home-content"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                overflow: "visible",
              }}
            >
              <div ref={parallaxRef} style={{ display: "inline-block", transition: "transform 0.08s linear" }}>
                <h1 className="creative-heading animate-on-scroll">BLU GOTLIEB</h1>
              </div>

              <div
                className="animate-on-scroll delay-1"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "0.5rem",
                  fontSize: "clamp(1rem, 3vw, 1.5rem)",
                }}
              >
                <span className="terminal-prompt">~/portfolio $</span>
                <Type />
              </div>

              <div className="status-indicator animate-on-scroll delay-2">
                <span className="status-dot"></span>
                Available for the right idea
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
      <Home2 />
    </section>
  );
}

export default Home;
